/**
 * Proyección isométrica REAL: mundo -> iso -> pantalla (punto 9 del brief).
 * No es un truco de rotación CSS: convierte coordenadas de mundo continuas
 * (x, y en tiles) a coordenadas de pantalla mediante la matriz isométrica 2:1.
 */

/** Ancho/alto de un tile en píxeles (proyección 2:1 clásica). */
export const TILE_W = 128;
export const TILE_H = 64;

export interface ScreenPos {
  sx: number;
  sy: number;
}

/** Mundo (x,y en tiles) -> pantalla (relativa al origen del mapa). */
export function worldToIso(x: number, y: number): ScreenPos {
  return {
    sx: (x - y) * (TILE_W / 2),
    sy: (x + y) * (TILE_H / 2),
  };
}

/** Pantalla (relativa al origen) -> mundo. Útil para click-to-move. */
export function isoToWorld(sx: number, sy: number): { x: number; y: number } {
  const a = sx / (TILE_W / 2);
  const b = sy / (TILE_H / 2);
  return { x: (a + b) / 2, y: (b - a) / 2 };
}

/**
 * Profundidad de dibujo (depth-sort). Un objeto "más al fondo" (menor x+y)
 * se pinta antes. Multiplicamos para dejar hueco a sub-orden dentro del tile.
 */
export function isoDepth(x: number, y: number): number {
  return (x + y) * 10;
}
